import { Component } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';

@Component({
  selector: 'app-problem',
  standalone: true,
  imports: [SectionHeadingComponent],
  templateUrl: './problem.component.html',
  styleUrl: './problem.component.scss',
})
export class ProblemComponent {
  classic = [
    'Prowadzący wybiera konkretne osoby',
    'Wyciąga je na środek sali',
    'Presja i oczy całej sali',
    'Część gości ucieka do stołu',
  ];

  weseleLive = [
    'Każdy sam decyduje, czy uczestniczy',
    'Gra ze swojego miejsca, bez presji',
    'Zero żenady, uczestniczenie z wyboru',
    'Cała sala reaguje razem',
  ];
}
